export default __webpack_public_path__ + "static/media/data_¿quienes-responden.1fa22e7b.png";